module.exports = "/images/cooper-5.jpg";